<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListSale()" isJump />
    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      class="parent-table"
      size="mini"
      show-footer
      border="none"
      :showOverflow="false"
      :row-config="{ isCurrent: false, isHover: false }"
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 36 - 148"
      :footer-method="footerMethod"
    >
      <template #header_content>
        <div class="parent-header">
          <div class="flex flex-y-center">
            <el-form class="flex flex-y-center" @submit.native.prevent="searchListData">
              <span>销售日期：</span>
              <e-date-picker
                type="daterange"
                :value.sync="filterData.bill_date"
                @change="searchListData"
              />
              <span class="m-l-10">模糊搜索：</span>
              <el-input
                style="width: 180px"
                size="mini"
                placeholder="请输入客户名称/业务员"
                v-model="keyword"
                clearable
                @clear="searchListData"
              />
              <el-button
                class="m-l-10"
                type="primary"
                size="mini"
                icon="el-icon-search"
                @click="searchListData"
              >
                搜索
              </el-button>
            </el-form>
          </div>
        </div>
      </template>
      <template #default_content="{ row, rowIndex }">
        <div class="parent-content">
          <div class="child-header">
            <div class="flex flex-y-center">
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">销售单号：</span>
                <el-link type="primary" @click="itemDetail(row.id)">
                  {{ row.bill_code }}
                </el-link>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">销售日期：</span>
                <span class="c-gray-deep">
                  {{ row.bill_date && row.bill_date.slice(0, 10) }}
                </span>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">交货日期：</span>
                <span class="c-gray-deep">
                  {{ row.jiao_huo_ri_qi && row.jiao_huo_ri_qi.slice(0, 10) }}
                </span>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">订单金额：</span>
                <b class="c-orange">{{ row.sales_amount_total }}元</b>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">客户名称：</span>
                <el-link type="primary" @click="customerFollowUpDetail(row.company_id)">{{
                  row.company_name
                }}</el-link>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">业务员：</span>
                <span class="c-gray-deep">{{ row.saler_name }}</span>
              </div>
              <div class="flex flex-y-center m-r-15">
                <el-link class="f-bold" type="primary" @click="itemRecord(row)">收款记录</el-link>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">送货单金额：</span>
                <b class="c-orange">{{ row.out_bill_money }}元</b>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">已收金额：</span>
                <b class="c-orange">{{ row.amount_received }}元</b>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">送货未收金额：</span>
                <b class="c-orange">{{ row.un_amount_received }}元</b>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">备注：</span>
                <span class="c-gray-deep">{{ row.bill_remark }}</span>
              </div>
            </div>
          </div>
          <vxe-grid
            :ref="`refSubTable_${rowIndex}`"
            class="child-table"
            size="mini"
            show-footer
            :row-config="{ isCurrent: false, isHover: false }"
            :columns="subTableColumn"
            :data="row.tableSaleData"
            :footer-method="subFooterMethod"
          >
            <!-- slot_default -->
            <template #default_photo_list="{ row }">
              <e-upload-image v-if="row.photo_list" :list.sync="row.photo_list" disabled />
            </template>
          </vxe-grid>
        </div>
      </template>

      <template #footer_content>
        <div class="flex">
          <span class="m-r-15 m-l-5">合计</span>
          <span class="m-r-15">
            <span>订单金额：</span>
            <span class="f-bold c-orange">{{ totalObj.sales_amount_total_all }}元</span>
          </span>
          <span class="m-r-15">
            <span>送货单金额：</span>
            <span class="f-bold c-orange">{{ totalObj.out_bill_money_all }}元</span>
          </span>
          <span class="m-r-15">
            <span>已收金额：</span>
            <span class="f-bold c-orange">{{ totalObj.amount_received_all }}元</span>
          </span>
          <span class="m-r-15">
            <span>送货未收金额：</span>
            <span class="f-bold c-orange">{{ totalObj.un_amount_received_all }}元</span>
          </span>
        </div>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-收款记录 -->
    <PopupRecord v-if="isShowPopupRecord" :show.sync="isShowPopupRecord" :detailId="activeBillId" />

    <!-- 弹窗-跟进记录 -->
    <b-popup-customer-follow-up-detail
      v-if="isShowPopupCustomerFollowUpDetail"
      :show.sync="isShowPopupCustomerFollowUpDetail"
      :id="activeId"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupRecord: () => import('../list/popup-record')
  },
  data() {
    return {
      loading: true,
      keyword: '',

      // filter
      filterData: {
        bill_date: [this.$util.getDate().monthDay, this.$util.getDate().today],
        status: 2 // 审核通过
      },
      sortData: {
        bill_id: 'desc'
      },

      // table
      headerFilterUrl: '/admin/gcvip/checkBill/searchHeard',
      tableData: [],
      tableColumn: [
        {
          title: '表格头部内容',
          slots: { header: 'header_content', default: 'default_content', footer: 'footer_content' }
        }
      ],
      subTableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '产品图片',
          field: 'photo_list',

          width: 63,
          slots: { default: 'default_photo_list' }
        },
        {
          title: '品名',
          field: 'craft',

          width: 200
        },
        {
          title: '规格',
          field: 'sales_specification',

          width: 200
        },
        {
          title: '单位',
          field: 'unit',

          width: 120
        },
        {
          title: '数量',
          field: 'counts',

          width: 120
        },
        {
          title: '单价(元)',
          field: 'sales_price',

          width: 120
        },
        {
          title: '金额(元)',
          field: 'sales_amount',

          width: 120
        },
        {
          title: '',
          field: ''
        }
      ],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        sales_amount_total_all: '',
        out_bill_money_all: '',
        amount_received_all: '',
        un_amount_received_all: ''
      },
      activeId: null,
      isShowPopupRecord: false,
      isShowPopupCustomerFollowUpDetail: false
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/checkBill/list',
        data: {
          keyword: this.keyword,
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          filterData: this.filterData,
          sortData: this.sortData
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = data.list
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
            this.totalObj.sales_amount_total_all = res.data.sales_amount_total_all
            this.totalObj.out_bill_money_all = res.data.out_bill_money_all
            this.totalObj.amount_received_all = res.data.amount_received_all
            this.totalObj.un_amount_received_all = res.data.un_amount_received_all
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) return '合计'
        })
      ]
    },
    // 子表格底部
    subFooterMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'sales_amount'].includes(column.field)) {
            return this.$util.listFieldTotal(data, column.field)
          }
        })
      ]
    },
    // 项-详情
    itemDetail(id) {
      window.open(`/sale/verify/detail?id=${id}`, '_blank')
    },
    // 项-收款记录
    itemRecord(row) {
      this.activeBillId = row.bill_id
      this.isShowPopupRecord = true
    },
    // 客户跟进-详情
    customerFollowUpDetail(id) {
      this.activeId = id
      this.isShowPopupCustomerFollowUpDetail = true
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
